export enum BalanceOperationControlsServiceKeys {
  GET_BALANCE_OPERATION_CONTROLS = 'GET_BALANCE_OPERATION_CONTROLS',
}
